import { Api, HttpClient } from "./ServerEndpoints";
import { config } from "./config";

const httpClient = new HttpClient({
  baseURL: config.apiUrl,
});
export const apiClient = new Api(httpClient);
